import {
  DOCUMENT_STATUS,
  DOCUMENT_TYPES,
  SERVICES,
} from '@savgroup-front-common/constants';
import {
  DOCUMENT_UPLOADER_TYPE,
  MessageType,
} from '@savgroup-front-common/types';

import globalMessages from '../helpers/i18n';

import { safeFormattedIntlString } from './safeFormattedIntlString';

export interface DocumentData {
  additionalInfo?: string;
  documentName: string;
  fileId?: string;
  moduleDefinitionId?: string;
  moduleInstanceId?: string;
  fromActor?: string;
  toActor?: string;
  type?: string;
  documentType?: DOCUMENT_TYPES;
  inProgress?: boolean;
  uniqueName?: string;
  url?: string;
  disabled?: boolean;
  uploaderFullName?: string;
  uploadDateUtc?: string;
  uploaderType?: DOCUMENT_UPLOADER_TYPE;
  extension?: string;
  attachmentId?: string;
  customerVisibility?: boolean;
  originalFileName?: string;
  service?: SERVICES;
  counter?: number;
  label?: string;
  carrierLabelId?: string;
  fileName?: string;
  referencedObjectId?: string;
}

const getDocumentNameTranslated = ({
  documentData,
}: {
  documentData: DocumentData;
}): string => {
  const {
    documentName,
    fileId,
    moduleDefinitionId,
    moduleInstanceId,
    fromActor,
    toActor,
    inProgress,
    uniqueName,
    fileName,
    documentType,
  } = documentData;
  const messages = globalMessages.documentMessages as Record<
    string,
    MessageType
  >;

  if (documentType === DOCUMENT_TYPES.PACKING_LIST) {
    return safeFormattedIntlString(messages.PackingList);
  }

  if (
    (fileId && moduleDefinitionId && moduleInstanceId) ||
    (documentName === DOCUMENT_STATUS.REGENERATE && inProgress)
  ) {
    if (fromActor && toActor && messages[fromActor] && messages[toActor]) {
      return safeFormattedIntlString(messages.ShippingLabel, {
        sourceAndDestination: `${safeFormattedIntlString(
          messages[fromActor],
        )} → ${safeFormattedIntlString(messages[toActor])}`,
        fileName,
      });
    }

    return safeFormattedIntlString(messages.ShippingLabel, {
      sourceAndDestination: null,
      fileName,
    });
  }

  if (documentName && uniqueName && messages[uniqueName]) {
    const documentNameForAddInfo = messages[documentName]
      ? safeFormattedIntlString(messages[documentName], {
          fileName,
        })
      : documentName;

    return safeFormattedIntlString(messages[uniqueName], {
      documentName: documentNameForAddInfo,
      fileName,
    });
  }

  if (documentName && messages[documentName]) {
    return safeFormattedIntlString(messages[documentName], {
      fileName,
    });
  }

  return documentName || '';
};

export default getDocumentNameTranslated;
